<template>
  <div>
    <Breadcrumbs
      :breadcrumbs="[
     {title: this.$t(`menu.${serviceSlug}`), disabled: true},
     {title: this.$t('menu.iframe/project-builder'), disabled: true}
   ]">
      <div slot="breadcrumbAfter" class="d-flex align-items-center">
        <Searchable class="mr-2" :querySearch.sync="querySearch" />
        <Filters
          :isActive="showFilters"
          :activeFilters="activeFilters"
          @toggle-filters="toggleFilters" />
        <span>
          <va-popover
            v-if="selectedProjectsIds.length > 0"
            placement="left"
            :message="$t('iframe.actions.delete')">
            <span class="icon fa fa-trash-o clickable" @click.prevent="deleteProjects"></span>
          </va-popover>
        </span>
      </div>
    </Breadcrumbs>

    <FadeTransition
      :duration="400"
      mode="out-in">
      <div class="btn btn__floating btn__round__large btn__round__large"
           v-if="writeEntities.length > 0">
        <va-popover
          :message="$t('iframe.titles.create_flow')"
          placement="left"
        >
          <va-button
            @click.prevent="onClickCreateProject">
            <i class="fa fa-plus"></i>
          </va-button>

        </va-popover>

      </div>
    </FadeTransition>

    <ProjectsTable
      ref="iframeProjectsTable"
      :showFilters.sync="showFilters"
      :querySearch="querySearch"
      @filters-updated="onFiltersUpdated"
      @flowClicked="onFlowClicked"
      @projectsSelected="onSelectedProjects"
      :component="component"
      :filtersOptions="['created_at', 'client']"
      :clientOptions="clientOptions"
      parentRef="iframeProjectsTable"
      />

    <CreateProject
      v-if="showCreateProject"
      :clientOptions="writeEntities"
      @cancel="onProjectCreateCancel"
      @created="onCreated"
      />
  </div>
</template>

<script>
import Breadcrumbs from "@/components/common/Breadcrumbs";
import Filters from "@/components/common/Filters";
import Searchable from "@/components/common/Searchable";
import IndexTablesMixin from "@/mixins/IndexTablesMixin";
import {TABLE_IFRAME_PROJECT_BUILDER} from "@/local-storage/LocalStorageKeys";
import ProjectsTable from "@/components/iframe/project-builder/ProjectsTable";
import FadeTransition from "@/components/common/transitions/FadeTransition";
import UpdateFlow from "@/components/iframe/project-builder/CreateProject";
import CreateProject from "@/components/iframe/project-builder/CreateProject";
export default {
  components: {CreateProject, UpdateFlow, FadeTransition, ProjectsTable, Searchable, Filters, Breadcrumbs},
  computed: {
    entities: function () {
      //let iframeService = this.$store.state.services.find(service => service.url === this.$store.state.iframe_server) || null
      if (this.iframeService) {
        return this.iframeService.entities
      }
      return null
    },
    flowPermissions: function () {
      return this.iframeService.user_permissions.filter(permission => permission.access_type >= 2 && permission.info_type === 100)
    },
    iframeService: function () {
      return this.$store.state.services.find(service => service.slug === 'iframe') || null
      //return this.$store.state.services.find(service => service.url === this.$store.state.iframe_server) || null
    },
    writeEntities: function () {
      return this.entities.filter(entity => this.flowPermissions.some(permission => permission.entity_id === null || permission.entity_id === entity.id)) || []
    },
    clientOptions: function () {
      if (!this.iframeService) {
        return []
      }
      const perms = this.iframeService.user_permissions.filter(perm => perm.access_type >= 1 && perm.info_type === 100)
      if (perms.some(perm => perm.entity_id === null)) {
        return this.iframeService.entities || []
      }
      const allowedIds = perms.map(perm => perm.entity_id)
      return (this.iframeService.entities || []).filter(entity => allowedIds.includes(entity.id))
    }
  },
  data () {
    return {
      querySearch: '',
      showFilters: false,
      activeFilters: 0,
      localStorageKey: TABLE_IFRAME_PROJECT_BUILDER,
      customQueries: null,
      selectedFlow: null,
      showCreateProject: false,
      selectedProjectsIds: []
    }
  },
  methods: {
    deleteProjects: function() {
      //TODO
       //console.log(this.selectedProjectsIds)
    },
    onClickCreateProject: function () {
      this.showCreateProject = true
    },
    onCreated: function() {
      this.showCreateProject = false
      this.refreshTable()
    },
    onFiltersUpdated: function (activeFilters) {
      this.activeFilters = activeFilters
    },
    onFlowClicked: function(row) {
      this.$router.push( `/${this.iframeService.slug}/${this.iframeService.slug}/project-builder/${row.hash}` )
    },
    onProjectCreateCancel: function() {
      this.showCreateProject = false
    },
    onSelectedProjects: function(selectedProjects) {
      if(selectedProjects.length > 0) {
        this.selectedProjectsIds = selectedProjects.map(elem => elem.id)
      } else { this.selectedProjectsIds = []}
    },
    refreshTable: function() {
      this.$refs.iframeProjectsTable.refresh()
    },
    toggleFilters: function () {
      this.showFilters = !this.showFilters
    },
  },
  mixins: [
    IndexTablesMixin
  ],
  props: {
    component: {
      type: Object,
      required: true
    },
    serviceSlug: {
      type: String,
      required: true
    },
  }
}
</script>

<style scoped>

</style>
